import API, { defaultHeaders } from '@/api';

const fetchListing = (page = 1, query = null) => {
  const headers = Object.assign({}, defaultHeaders);
  headers.Authorization = `Bearer ${sessionStorage.getItem('token')}`;

  let queryString = null;
  if (query !== null && typeof query === 'string') {
    queryString = query;
  }
  else if (query !== null && typeof query === 'object') {
    queryString = Object.keys(query).map(key => `${encodeURIComponent(key)}=${encodeURIComponent(query[key])}`)
      .join('&')
    ;
  }

  return fetch(`${API}/panel/codes?page=${page}${queryString!== null && queryString.length > 0 ? `&${queryString}` : ''}`, { headers });
};

export default fetchListing;
